import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import employee from "../images/employee_development.png"
import develop from "../images/employee_develop.png"
import innovative from "../images/innovative-solutions.png"
import strongRelation from "../images/strong-relationship.png"
import quality from "../images/quality-delivery.png"
import integrity from "../images/integrity.png"
import collaboration from "../images/collaboration.png"
import customer from "../images/customer-centercity.png"
import excellence from "../images/excellence.png"
import tech from "../images/technology.png"
import sustainableDevlop from "../images/sustainable-development.png"
import expectations from "../images/expectations.png"
import { Link } from "react-scroll";


const sections = [
              {
                title: "Vision",
                items: [
                  {
                    title: "Client Empowerment",
                    description:
                      " Enabling clients to harness innovative IT solutions that drive business growth and success.",
                    icon: employee,
                  },
                  {
                    title: "Employee Development",
                    description:
                      "Fostering a supportive environment that unlocks career potential through continuous learning and skill enhancement.",
                    icon: develop,
                  },
                  {
                    title: "Sustainable Growth",
                    description:
                      "Achieving financial strength for both employees and shareholders through responsible and sustainable business practices.",
                    icon: sustainableDevlop,
                  },
                  {
                    title: "Technology Leadership",
                    description:
                      "Staying at the forefront of technological advancements to deliver cutting-edge solutions. ",
                    icon: tech,
                  },
                 
                ],
              },
              {
                title: "Mission",
                items: [
                  {
                    title: "Innovative Solutions",
                    description:
                      "Develop creative solutions that provide a competitive advantage and high business value to our clients.",
                    icon: innovative,
                  },
                  {
                    title: "Strong Relationships",
                    description:
                      "Build long-lasting relationships with employees, customers, and partners based on trust and collaboration.",
                    icon: strongRelation,
                  },
                  {
                    title: "Quality Delivery",
                    description:
                      "Deliver high-quality products and services at competitive prices, ensuring timely execution and client satisfaction.",
                    icon: quality,
                  },
                  {
                    title: "Exceeding Expectations",
                    description:
                      "Consistently surpass stakeholder expectations by going above and beyond in everything we do.",
                    icon: expectations,
                  },
                 
                ],
              },
              {
                title: "Values",
                items: [
                  {
                    title: "Integrity",
                    description:
                      "We uphold the highest standards of honesty and transparency in all our interactions.",
                    icon: integrity,
                  },
                 
                  {
                    title: "Collaboration",
                    description:
                      "We believe in the power of teamwork — working hand-in-hand with clients, partners, and each other.",
                    icon: collaboration,
                  },
                  {
                    title: "Customer-Centricity",
                    description:
                      "Our client's success is our success; we prioritize their needs and strive to exceed expectations.",
                    icon: customer,
                  },
                  {
                    title: "Excellence",
                    description:
                      "We pursue the highest quality in our products, services, and internal processes.",
                    icon: excellence,
                  },
                ],
              },
          ];
const ScrollSection = () => {
  return (
    <Box
      sx={{
        py: 10,
        px: { xs: 2, md: 6 },
        backgroundImage:
          "linear-gradient(to right, rgba(255, 192, 203, 1), rgba(255, 192, 203, 0.2), rgba(173, 216, 230, 0.2),rgba(173, 216, 230, 1))",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: 6,
        mx: "auto",
        maxWidth: "1700px",
        my : "50px"
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
       <Box sx={{ display: "flex", justifyContent: "center" }}>
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#fff",
      px: 2,
      py: 0.5,
      borderRadius: 10,
      border: "0.5px solid gray",
      fontWeight: 600,
      gap: 0.5,
      justifyContent: "center",
    }}
  >
    <AutoFixHighIcon sx={{ mx: 1, color: "blue" }} />
    <Typography
      variant="h6"
      fontWeight="bold"
      align="center"
      sx={{
        fontSize: { xs: 13, md: 15 },
      }}
    >
      We are Censoft
    </Typography>
  </Box>
</Box>

        {/* <br /> */}
        {/* <Typography variant="h4" align="center" fontWeight="bold" gutterBottom >
          Committed to Your SEO Success
        </Typography> */}
        <Box
          sx={{
            mt: 4,
            maxWidth: "1500px",
            mx: "auto",
            px: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              flexWrap: "wrap",
              gap: 4,
            }}
          >
           {sections.map((section, i) => (
   <>
      <Box sx={{ flex: 1 ,}}>
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ textAlign: "center" }}
          gutterBottom
        >
          {section.title}
        </Typography>

        <Box mt={2}>
          {section.items.map((item, j) => (
            <Box
              key={j}
              sx={{ display: "flex", alignItems: "center", mb: 3 }}
            >
              <Box
                component="img"
                src={item.icon}
                alt={`${item.title} Icon`}
                sx={{ 
                width: 50,
                  height: 50,
                  mr: 2,
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  p: 1,
                  objectFit: "contain",      // 🔥 Image fits inside rounded box
                  display: "block",  
                  border : "1px solid #d8d8d8"
                  }}

              />
              <Typography
                variant="subtitle1"
                sx={{ fontSize: "1.1rem" }}
              >
                <strong>{item.title}:</strong> {item.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {/* ✅ Show vertical divider between columns */}
      {i < sections.length - 1 && (
        <Box
          sx={{
            width: "1px",
            height: "auto",
            backgroundColor: "#e8e8e8",
            mx: 3,
          }}
        />
      )}
    </>
  ))}
          </Box>
        </Box>

        <Box textAlign="center" mt={6}>
          <Link
          key="about"
          to="about"
           smooth={true}
            duration={500}
            offset={-80}

          >
          <Button
            variant="h2"
            color="primary"
            sx={{
              position : "relative",
              overflow : "hidden",
              backgroundColor: "#032262",
              color: "white",
              mt: 3,
              px: 6,
              py: 2,
              fontSize: "1rem",
              textTransform: "none",
              zIndex : 1,
              "&::before": {
                content: "''",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#a10304",
                transform: "translateY(100%)",
                transition: "transform 0.3s ease-in-out",
                zIndex: -1,
              },
              "&:hover::before": {
                transform: "translateY(0%)",
              },
              "&:hover": {
                color : "white"
              }
            }}
          >
            Learn more about us
          </Button>
          </Link>
        </Box>
      </motion.div>
    </Box>
  );
};

export default ScrollSection;
